// This icon file is generated automatically.
var SmallDashOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M112 476h72v72h-72zm182 0h72v72h-72zm364 0h72v72h-72zm182 0h72v72h-72zm-364 0h72v72h-72z"
      }
    }]
  },
  "name": "small-dash",
  "theme": "outlined"
};
export default SmallDashOutlined;